const ROOT_URL = '';

export default [
    {
        name: 'invoice.pay',
        path: ROOT_URL + '/payment/invoice/pay',
        component: () => import ('@crewlixSrc/views/invoice/Index.vue'),
    },

    {
        name: 'payment.completed',
        path: ROOT_URL + '/payment/completed',
        component: () => import ('@crewlixSrc/views/PaymentCompleted.vue'),
    },

    {
        name: 'index',
        path: ROOT_URL + '/payment',
        component: () => import ('@crewlixSrc/views/Index.vue'),
    },

    {
        name: 'checkout.paddle',
        path: ROOT_URL + '/payment/subscription/checkout/:tenantId/:userId',
        component: () => import ('@crewlixSrc/views/checkout/Index.vue'),
    },
    {
        path: "/:pathMatch(.*)*",
        name: "not-found",
        component: () => import ('@crewlixSrc/views/NotFound.vue'),
    },
];
